import KText from "./KText.vue";
export default KText;
